import {
  Injectable,
  ComponentRef,
  ComponentFactoryResolver,
  ApplicationRef,
  Injector,
  EmbeddedViewRef,
} from '@angular/core';
import { TimeoutPopupComponent } from '../components/timeout-popup/timeout-popup.component';

@Injectable({
  providedIn: 'root',
})
export class TimeoutPopupService {
  popupComponentRef: ComponentRef<TimeoutPopupComponent>;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector
  ) {}

  public open() {
    this.appendDialogComponentToBody();
  }

  public close() {
    this.removeDialogComponentFromBody();
  }

  private appendDialogComponentToBody() {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(TimeoutPopupComponent);
    const componentRef = componentFactory.create(this.injector);
    this.appRef.attachView(componentRef.hostView);

    const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);

    this.popupComponentRef = componentRef;
  }

  private removeDialogComponentFromBody() {
    this.appRef.detachView(this.popupComponentRef.hostView);
    this.popupComponentRef.destroy();
  }
}
